import { ArrowLeft, Clock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardSubtitle, CardTitle } from '@/shared/components/ui'

interface ComingSoonPageProps {
  /** Título principal (ej. "Mi organización"). */
  title: string
  /** Subtítulo opcional con el contexto. Default genérico. */
  subtitle?: string
  /** Marca opcional encima del título. Default "Próximamente". */
  tag?: string
}

/**
 * Página placeholder para módulos del portal que aún no se implementan.
 * Sigue el lenguaje visual del prototipo (card centrada, serif para el título,
 * acento teal). El botón "Volver" navega al dashboard.
 *
 * Cuando una feature está lista, esta página se reemplaza por la real en
 * `MainRouter`.
 */
export function ComingSoonPage({
  title,
  subtitle = 'Esta sección se está construyendo. Pronto la tendrás disponible.',
  tag = 'Próximamente',
}: ComingSoonPageProps) {
  const navigate = useNavigate()

  return (
    <Card className="grid min-h-[480px] place-items-center px-6 py-16 text-center">
      <div className="max-w-md space-y-4">
        <span className="inline-flex items-center gap-1.5 rounded bg-ink px-2 py-1 text-[10px] font-bold uppercase tracking-[0.1em] text-white">
          <Clock className="h-3 w-3" />
          {tag}
        </span>
        <CardTitle className="font-serif text-3xl font-normal tracking-tight">
          {title}
        </CardTitle>
        <CardSubtitle className="text-base">{subtitle}</CardSubtitle>
        <Button onClick={() => navigate('/app')} variant="outline" className="mt-4">
          <ArrowLeft className="h-4 w-4" />
          Volver al panel
        </Button>
      </div>
    </Card>
  )
}
